import { fmtNum } from "@/lib/api";

export function StatCard({ title, value, unit, icon: Icon, tone = "sky", testId, hint, delay = "" }) {
  const tones = {
    sky: "bg-sky-100 text-sky-700", emerald: "bg-emerald-100 text-emerald-700",
    amber: "bg-amber-100 text-amber-700", rose: "bg-rose-100 text-rose-700", navy: "bg-slate-900 text-sky-300",
  };
  return (
    <div className={`card-aqua p-5 rise ${delay}`} data-testid={testId}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</div>
          <div className="mt-2 flex items-baseline gap-1.5">
            <span className="text-3xl font-extrabold tracking-tight text-slate-900 font-mono" data-testid={`${testId}-value`}>{fmtNum(value)}</span>
            <span className="text-sm font-semibold text-sky-700">{unit}</span>
          </div>
          {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
        </div>
        <div className={`h-11 w-11 rounded-xl flex items-center justify-center ${tones[tone]}`}>
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    tersedia: ["Tersedia", "bg-emerald-50 text-emerald-700 border-emerald-200"],
    rendah: ["Stok Rendah", "bg-amber-50 text-amber-700 border-amber-200"],
    habis: ["Habis", "bg-rose-50 text-rose-700 border-rose-200"],
  };
  const [label, cls] = map[status] || [status, "bg-slate-50 text-slate-600"];
  return <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>{label}</span>;
}

export function ExpiryBadge({ item }) {
  if (item.quantity_mc <= 0) return <span className="text-xs text-slate-300">—</span>;
  const d = item.days_to_expiry;
  const cls = item.expiry_status === "expired" ? "bg-rose-50 text-rose-700 border-rose-200" : item.expiry_status === "warning" ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-sky-50 text-sky-700 border-sky-100";
  const label = d < 0 ? `Lewat ${Math.abs(d)} hr` : d === 0 ? "Hari ini" : `${d} hari`;
  return <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border font-mono ${cls}`} title={`Kadaluarsa ${item.expiry_date}`}>{label}</span>;
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 rise">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h2>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        <div className="wave-line w-16 mt-3" />
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}
